<template>
    <div>
        <div v-if="isShowHomeVariant" id="home-variant-1">
            <home-header></home-header>
            <home-variant></home-variant>
            <home-footer></home-footer>
        </div>
        <div v-else id="home-control">
            <h1 class="heading--invisible">{{$t('meta.home.h1')}}</h1>
            <home-header></home-header>
            <home-top :isShowRibbon="isShowRibbon"></home-top>
            <slot></slot>
            <home-popular-deal :isMoveTips="isMoveTips"></home-popular-deal>
            <home-footer></home-footer>
        </div>
    </div>
</template>
<script>
    import { getExperiment } from '@pizza-hut/lib-experiments/lib'
    export default {
        components: {
            HomeHeader: () => import('@/components/home/HomeHeader.vue'),
            HomeTop: () => import('@/components/home/HomeTop.vue'),
            HomePopularDeal: () => import('@/components/home/HomePopularDeal.vue'),
            HomeFooter: () => import('@/components/home/HomeFooter.vue'),
            HomeVariant: () => import('@/components/home/HomeVariant.vue')
        },
        data() {
            return {
                isShowCoupon: true,
                isShowHomeVariant: false,
                isShowRibbon : true,
                isMoveTips : false
            }
        },
        created() {
            // const experiment = getExperiment('CVR', 'homeLayout')
            // if(experiment === this.getValueExperiment('homeLayout','oldHomePage')){
            //     this.isShowHomeVariant =false
            // }
            // if(experiment === this.getValueExperiment('homeLayout','newDesign')){
            //     this.isShowHomeVariant =true
            //     this.isShowRibbon =false
            // }
            // if(experiment === this.getValueExperiment('homeLayout','hideAndMoveBanner')){
            //     this.isShowHomeVariant =false
            //     this.isShowRibbon = false
            //     this.isMoveTips = true
            // }
            // if(experiment === null) {
            //     this.isShowHomeVariant =true
            //     this.isShowRibbon =false
            // }
            // console.log(getExperiment('CVR', 'homeLayout'))
        },
        mounted() {
            let body = document.body

            body.classList.remove('mainpage')
            body.classList.remove('mainpage-combo')
            body.classList.remove('combo-popup-items')
        },
        methods: {
            closeCouponPopup: function () {
                this.isShowCoupon = !this.isShowCoupon
            }
        }
    }
</script>
<style>
    body {
        padding-right: 0px;
        background: none;

    }
</style>



// WEBPACK FOOTER //
// src/layouts/Home.vue